import {
	CalendarNav,
	CalendarNext,
	CalendarPrev,
	CalendarToday,
} from '@mobiscroll/react';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { IWorkplaces } from 'module/workplaces/interface/WorkplacesInterface';
import { useCalendarView } from 'core/hooks/useCalendarView';
import EventsDatePicker from './EventsDatePicker';
import './EventsHeader.style.scss';

interface EventsHeaderProps {
	workplacesData: IWorkplaces;
	workplaceId: number;
	// optional callback to switch calendar type (e.g., to 'schedule')
	onSwitchCalendarType?: (type: 'schedule' | 'request' | 'event') => void;
	selectedDate?: string; // ISO format: YYYY-MM-DD
	setSelectedDate?: (date: string) => void;
	canCreateEvents?: boolean; // Permission to create events
}

export const EventsHeader: React.FC<EventsHeaderProps> = ({
	workplacesData,
	workplaceId,
	onSwitchCalendarType,
	selectedDate,
	setSelectedDate,
	canCreateEvents = true, // Default to true for backward compatibility
}) => {
	const { calendarView, setCalendarView } = useCalendarView();
	const history = useHistory();

	const workplaceName = workplacesData?.items?.find(
		(workplace) => workplaceId === +workplace.id
	)?.name || '';

	const handleCreateEvent = () => {
		// Preserve scroll position before navigating to create
		const scrollContainer = document.querySelector(
			'.mbsc-timeline-grid-scroll, .mbsc-schedule-grid-scroll, .mbsc-timeline-resource-scroll, .mbsc-schedule-resource-scroll'
		) as HTMLElement | null;
		if (scrollContainer) {
			localStorage.setItem('events-calendar-scroll', String(scrollContainer.scrollTop));
			localStorage.setItem('events-calendar-scroll-left', String(scrollContainer.scrollLeft));
			localStorage.setItem('events-calendar-restore-scroll', '1');
		}
		history.push({
			pathname: '/manager/events/create',
			state: {},
		});
	};

	return (
		<>
			<div className="customHeader EventsHeader">
				<div className="customHeaderTop">
					<div className="monthYearDisplay">
						{onSwitchCalendarType ? (
						<CalendarNav className="md-work-week-nav" />
						) : null}
					</div>
					<div className="workplaceContainer">
						{onSwitchCalendarType ? (
							<>
						<span className="WorkplaceTitle">
							Workplace: <span className="WorkplaceName">{workplaceName}</span>
						</span>
							<button
								className="switchToSchedule"
								onClick={() => onSwitchCalendarType('schedule')}
								style={{ marginLeft: 12 }}
							>
								Schedule
							</button>
							</>
						) : null}
					</div>
					<div className="addButtonContainer">
						{!onSwitchCalendarType ? (
						<div className="dateNavigationContainer">
							<CalendarPrev className="md-work-week-prev" />
							<CalendarToday className="md-work-week-today" />
							<CalendarNext className="md-work-week-next" />
						</div>
						) : null}
						{canCreateEvents && (
							<button className="addEventButton" onClick={handleCreateEvent}>
								Add
							</button>
						)}
					</div>
				</div>
				<div className="customHeaderMiddle">
					{onSwitchCalendarType ? (
						<div className="viewToggleContainer">
							<button
								className={`viewToggle ${calendarView === 'day' ? 'active' : ''}`}
								onClick={() => setCalendarView('day')}
							>
								Day
							</button>
							<button
								className={`viewToggle ${calendarView === 'week' ? 'active' : ''}`}
								onClick={() => setCalendarView('week')}
							>
								Week
							</button>
						</div>
					) : null}
				</div>
			</div>
		</>
	);
};

